import { useMemo, useState } from "react";

// v0.6.10 — extracted from CalculatePanel.jsx (500-LOC cap sweep).
// Filename search over "Your uploads", so an operator with many
// uploads can find one without scrolling. Runs BEFORE the (currently
// disabled) hide-duplicates pass in CalculatePanel.jsx, so the two
// compose correctly if that toggle is ever re-enabled: search narrows
// the candidate set first, then dedupe groups within whatever matched.
export const useUploadSearch = (prodRuns) => {
  const [uploadQuery, setUploadQuery] = useState("");
  const searchedProdRuns = useMemo(() => {
    const q = uploadQuery.trim().toLowerCase();
    if (!q) return prodRuns;
    return prodRuns.filter((r) => (r.filename || "").toLowerCase().includes(q));
  }, [prodRuns, uploadQuery]);
  return { uploadQuery, setUploadQuery, searchedProdRuns };
};
